// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsor-tab-container {
  padding: 14px 32px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .sponsor-tab-container {
    max-width: 450px;
  }
}

.sponsor-tab-image-container {
  display: flex; /* Use flexbox to center content if needed */
  justify-content: center; /* Center the image horizontally */
  margin: 16px 0; /* Add vertical spacing around the container */
}

.sponsor-tab-sponsor-header-image {
  width: 100%; /* Ensure the image takes up the full width of its container */
  margin: auto 0; /* Center horizontally and align to top */
  max-width: 500px; /* Default max width for larger screens */
}
@media (max-width: 900px) {
  .sponsor-tab-sponsor-header-image {
    max-width: 300px; /* Adjust max width for screens 900px or less */
  }
}

.sponsor-tab-main-sponsor-link {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #fff !important;
  background-color: #00AAD1 !important;
  text-decoration: underline;
  padding: 16px 0px;
}
@media (max-width: 900px) {
  .sponsor-tab-main-sponsor-link {
    font-size: 24px !important;
  }
}

.sponsor-tab-sponsor-link {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #00AAD1 !important;
  text-decoration: underline;
}
@media (max-width: 900px) {
  .sponsor-tab-sponsor-link {
    font-size: 14px !important;
  }
}

.sponsor-tab-main-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  font-family: "Inter", sans-serif;
  text-align: center;
}

.sponsor-tab-main-text-underline {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  font-family: "Inter", sans-serif;
  text-align: center;
  text-decoration: underline !important;
}

.sponsor-tab-main-text-first {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  font-family: "Inter", sans-serif;
  text-align: center;
  margin-top: 8px !important;
}

.sponsor-tab-header-text {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #002129;
  font-family: "Inter", sans-serif;
  text-align: center;
  margin-top: 32px !important;
  margin-bottom: 8px !important;
}

.sponsor-tab-location-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #00AAD1;
  font-family: "Inter", sans-serif;
  text-align: center;
}

.sponsor-tab-catering-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #00AAD1;
  font-family: "Inter", sans-serif;
  text-align: center;
  text-decoration: underline !important;
  cursor: pointer;
}

.sponsor-tab-locations-container {
  padding: 4px 32px;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .sponsor-tab-locations-container {
    max-width: 450px;
  }
}

.sponsor-tab-hours-block {
  margin-top: 16px;
  margin-bottom: 16px;
}

.sponsor-tab-header {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.sponsor-tab-icon {
  font-size: 24px;
  color: #00AAD1;
  transition: transform 0.3s ease;
}

.sponsor-tab-icon.open {
  transform: rotate(180deg);
}

.sponsor-tab-specials-container {
  margin-top: 16px;
  margin-bottom: 16px;
}

.sponsor-tab-body-line {
  display: flex;
  align-items: center;
  justify-content: center; /* Center content by default */
  margin-top: 8px; /* Optional: add some spacing between lines */
  width: 100%;
}

.sponsor-tab-body-line.with-image {
  justify-content: space-between; /* Distribute space between images and text */
}

.sponsor-tab-body-line.no-image {
  justify-content: center; /* Center text when no images are present */
}

.sponsor-tab-body-image {
  width: 24px;
  height: 24px;
  margin: 0 8px; /* Optional: add some spacing between the image and text */
}

.sponsor-tab-bottom-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  font-family: "Inter", sans-serif;
  text-align: center;
  margin-top: 32px !important;
}

.sponsor-highlights-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr) !important; /* Two columns by default */
  gap: 16px; /* Space between items */
  margin: 16px 0; /* Margin around the container */
  max-width: 900px;
  margin: 0 auto;
  padding: 0px 32px;
}
@media screen and (max-width: 900px) {
  .sponsor-highlights-container {
    max-width: 400px;
    grid-template-columns: repeat(1, 1fr) !important; /* Two columns by default */
  }
}

.sponsor-highlight-item {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center items horizontally */
  text-align: center; /* Center text */
}

.sponsor-highlight-name {
  font-size: 16px !important; /* Adjust font size as needed */
  font-weight: 700 !important; /* Adjust font weight as needed */
  margin-bottom: 8px !important; /* Space between name and image */
}
@media screen and (max-width: 900px) {
  .sponsor-highlight-name {
    font-size: 14px !important;
  }
}

.sponsor-highlight-image {
  width: 100%; /* Ensure image fits within its container */
  height: auto; /* Maintain aspect ratio */
  max-width: 350px; /* Max width for larger screens */
  margin-bottom: 32px !important; /* Space between image and name */
}
@media (max-width: 900px) {
  .sponsor-highlight-image {
    max-width: 4500px; /* Adjust width for smaller screens */
  }
}

.last-item {
  grid-column: span 2; /* Span two columns for the last item if odd number */
}

.sponsor-sister-location-item {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center items horizontally */
  text-align: center; /* Center text */
  margin-bottom: 32px;
}

.sponsor-sister-location-name {
  font-size: 20px !important; /* Adjust font size as needed */
  font-weight: 700 !important; /* Adjust font weight as needed */
  margin-bottom: 16px !important; /* Space between name and image */
}
@media screen and (max-width: 900px) {
  .sponsor-sister-location-name {
    font-size: 20px !important;
  }
}

.sponsor-sister-location-image {
  max-width: 350px; /* Max width for larger screens */
  margin-bottom: 32px !important; /* Space between image and name */
}
@media (max-width: 900px) {
  .sponsor-sister-location-image {
    max-width: 250px; /* Adjust width for smaller screens */
  }
}

.sponsor-sister-location-logo-container {
  height: 350px;
  width: 350px;
  display: flex; /* Enable flexbox for centering */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  overflow: hidden; /* Prevent logos from spilling out */
}
@media (max-width: 900px) {
  .sponsor-sister-location-logo-container {
    height: 250px; /* Adjust height for smaller screens */
    width: 250px; /* Adjust width for smaller screens */
  }
}

.sponsor-sister-location-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr) !important; /* Two columns by default */
  gap: 100px; /* Space between items */
  margin: 16px 0; /* Margin around the container */
  max-width: 900px;
  margin: 0 auto;
  padding: 0px 32px;
}
@media screen and (max-width: 900px) {
  .sponsor-sister-location-container {
    max-width: 400px;
    grid-template-columns: repeat(1, 1fr) !important; /* Two columns by default */
  }
}

.sponsor-sister-location-secondary-image {
  height: 350px; /* Maintain aspect ratio */
  max-width: 350px; /* Max width for larger screens */
  margin-bottom: 32px !important; /* Space between image and name */
}
@media (max-width: 900px) {
  .sponsor-sister-location-secondary-image {
    max-width: 4500px; /* Adjust width for smaller screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SponsorTab/SponsorTab.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACI;EARJ;IASM,gBAAA;EAEJ;AACF;;AAEE;EACE,aAAA,EAAA,4CAAA;EACA,uBAAA,EAAA,kCAAA;EACA,cAAA,EAAA,8CAAA;AACJ;;AAIE;EACE,WAAA,EAAA,8DAAA;EACA,cAAA,EAAA,yCAAA;EACA,gBAAA,EAAA,yCAAA;AADJ;AAGI;EALF;IAMM,gBAAA,EAAA,+CAAA;EAAN;AACF;;AAGA;EACE,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,oCAAA;EACA,0BAAA;EACA,iBAAA;AAAF;AAEE;EARF;IASI,0BAAA;EACF;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AACF;AACE;EANF;IAOI,0BAAA;EAEF;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;AACF;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,qCAAA;AACJ;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;AACJ;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,2BAAA;EACA,6BAAA;AACJ;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;AACJ;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;AACJ;;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACI;EARF;IASI,gBAAA;EAEJ;AACF;;AACE;EACE,gBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAEJ;;AACA;EACI,eAAA;EACA,cAAA;EACA,+BAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA,EAAA,8BAAA;EACA,eAAA,EAAA,6CAAA;EACA,WAAA;AAEJ;;AACA;EACI,8BAAA,EAAA,6CAAA;AAEJ;;AACA;EACI,uBAAA,EAAA,2CAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,aAAA,EAAA,0DAAA;AAEJ;;AACA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,2BAAA;AAEJ;;AACE;EACE,aAAA;EACA,gDAAA,EAAA,2BAAA;EACA,SAAA,EAAA,wBAAA;EACA,cAAA,EAAA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAEJ;AAAI;EATF;IAUM,gBAAA;IACA,gDAAA,EAAA,2BAAA;EAGN;AACF;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA,EAAA,8BAAA;EACA,kBAAA,EAAA,gBAAA;AACJ;;AAEA;EACI,0BAAA,EAAA,+BAAA;EACA,2BAAA,EAAA,iCAAA;EACA,6BAAA,EAAA,iCAAA;AACJ;AACI;EALJ;IAMQ,0BAAA;EAEN;AACF;;AAEA;EACI,WAAA,EAAA,2CAAA;EACA,YAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,iCAAA;AACJ;AACI;EANJ;IAOQ,iBAAA,EAAA,qCAAA;EAEN;AACF;;AACA;EACI,mBAAA,EAAA,qDAAA;AAEJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA,EAAA,8BAAA;EACA,kBAAA,EAAA,gBAAA;EACA,mBAAA;AACF;;AAGA;EACE,0BAAA,EAAA,+BAAA;EACA,2BAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,iCAAA;AAAF;AAEE;EALF;IAMM,0BAAA;EACJ;AACF;;AAGA;EACE,gBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,iCAAA;AAAF;AAEE;EAJF;IAKM,gBAAA,EAAA,qCAAA;EACJ;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,aAAA,EAAA,iCAAA;EACA,mBAAA,EAAA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,gBAAA,EAAA,oCAAA;AACF;AACE;EARF;IASM,aAAA,EAAA,sCAAA;IACA,YAAA,EAAA,qCAAA;EAEJ;AACF;;AACA;EACE,aAAA;EACA,gDAAA,EAAA,2BAAA;EACA,UAAA,EAAA,wBAAA;EACA,cAAA,EAAA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAEF;AAAE;EATF;IAUM,gBAAA;IACA,gDAAA,EAAA,2BAAA;EAGJ;AACF;;AAEA;EACE,aAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,iCAAA;AACF;AACE;EALF;IAMM,iBAAA,EAAA,qCAAA;EAEJ;AACF","sourcesContent":[".sponsor-tab-container {\n    padding: 14px 32px; // 24px top/bottom and 32px left/right\n    max-width: 600px; // Default max-width for larger screens\n    display: flex;\n    flex-direction: column;\n    align-items: center; // Horizontally center all items\n    margin: 0 auto; // Center the container itself horizontally\n  \n    @media (max-width: 900px) {\n      max-width: 450px; // Adjust max-width for smaller screens\n    }\n  }\n\n\n  .sponsor-tab-image-container {\n    display: flex; /* Use flexbox to center content if needed */\n    justify-content: center; /* Center the image horizontally */\n    margin: 16px 0; /* Add vertical spacing around the container */\n}\n\n\n\n  .sponsor-tab-sponsor-header-image {\n    width: 100%; /* Ensure the image takes up the full width of its container */\n    margin: auto 0; /* Center horizontally and align to top */\n    max-width: 500px; /* Default max width for larger screens */\n\n    @media (max-width: 900px) {\n        max-width: 300px; /* Adjust max width for screens 900px or less */\n    }\n}\n\n.sponsor-tab-main-sponsor-link {\n  font-size: 24px !important;\n  font-weight: 700 !important;\n  color: #fff !important;\n  background-color: #00AAD1 !important;\n  text-decoration: underline;\n  padding: 16px 0px;\n\n  @media (max-width: 900px) {\n    font-size: 24px !important;\n  }\n}\n\n.sponsor-tab-sponsor-link {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  color: #00AAD1 !important;\n  text-decoration: underline;\n\n  @media (max-width: 900px) {\n    font-size: 14px !important;\n  }\n}\n\n  \n.sponsor-tab-main-text {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  color: #002129;\n  font-family: 'Inter', sans-serif;\n  text-align: center;\n}\n\n  .sponsor-tab-main-text-underline {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n    text-decoration: underline !important;\n  }\n\n  .sponsor-tab-main-text-first {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n    margin-top: 8px !important; // Space between main text and header\n  }\n  \n  .sponsor-tab-header-text {\n    font-size: 20px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n    margin-top: 32px !important; // Space between main text and header\n    margin-bottom: 8px !important; // Space between header and locations\n  }\n\n  .sponsor-tab-location-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #00AAD1;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n  }\n\n  .sponsor-tab-catering-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #00AAD1;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n    text-decoration: underline !important;\n    cursor: pointer;\n  }\n\n  .sponsor-tab-locations-container {\n    padding: 4px 32px; // 16px top/bottom and 32px left/right\n    max-width: 550px; // Default max-width for larger screens\n    display: flex;\n    flex-direction: column;\n    align-items: center; // Horizontally center all items\n    margin: 0 auto; // Center the container itself horizontally\n  \n    @media (max-width: 900px) {\n      max-width: 450px; // Adjust max-width for smaller screens\n    }\n  }\n\n  .sponsor-tab-hours-block {\n    margin-top: 16px;\n    margin-bottom: 16px;\n}\n\n.sponsor-tab-header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    width: 100%;\n}\n\n.sponsor-tab-icon {\n    font-size: 24px;\n    color: #00AAD1;\n    transition: transform 0.3s ease;\n}\n\n.sponsor-tab-icon.open {\n    transform: rotate(180deg); // Flip the icon when open\n}\n\n.sponsor-tab-specials-container {\n    margin-top: 16px;\n    margin-bottom: 16px;\n}\n\n.sponsor-tab-body-line {\n    display: flex;\n    align-items: center;\n    justify-content: center; /* Center content by default */\n    margin-top: 8px; /* Optional: add some spacing between lines */\n    width: 100%;\n}\n\n.sponsor-tab-body-line.with-image {\n    justify-content: space-between; /* Distribute space between images and text */\n}\n\n.sponsor-tab-body-line.no-image {\n    justify-content: center; /* Center text when no images are present */\n}\n\n.sponsor-tab-body-image {\n    width: 24px;\n    height: 24px;\n    margin: 0 8px; /* Optional: add some spacing between the image and text */\n}\n\n.sponsor-tab-bottom-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    font-family: 'Inter', sans-serif;\n    text-align: center;\n    margin-top: 32px !important;\n  }\n\n  .sponsor-highlights-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr) !important; /* Two columns by default */\n    gap: 16px; /* Space between items */\n    margin: 16px 0; /* Margin around the container */\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 0px 32px;\n\n    @media screen and (max-width: 900px) {\n        max-width: 400px;\n        grid-template-columns: repeat(1, 1fr) !important; /* Two columns by default */\n\n        \n    }\n}\n\n.sponsor-highlight-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center items horizontally */\n    text-align: center; /* Center text */\n}\n\n.sponsor-highlight-name {\n    font-size: 16px !important; /* Adjust font size as needed */\n    font-weight: 700 !important; /* Adjust font weight as needed */\n    margin-bottom: 8px !important; /* Space between name and image */\n\n    @media screen and (max-width: 900px) {\n        font-size: 14px !important; \n        \n    }\n}\n\n.sponsor-highlight-image {\n    width: 100%; /* Ensure image fits within its container */\n    height: auto; /* Maintain aspect ratio */\n    max-width: 350px; /* Max width for larger screens */\n    margin-bottom: 32px !important; /* Space between image and name */\n    \n    @media (max-width: 900px) {\n        max-width: 4500px; /* Adjust width for smaller screens */\n    }\n}\n\n.last-item {\n    grid-column: span 2; /* Span two columns for the last item if odd number */\n}\n\n\n.sponsor-sister-location-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Center items horizontally */\n  text-align: center; /* Center text */\n  margin-bottom: 32px;\n}\n\n\n.sponsor-sister-location-name {\n  font-size: 20px !important; /* Adjust font size as needed */\n  font-weight: 700 !important; /* Adjust font weight as needed */\n  margin-bottom: 16px !important; /* Space between name and image */\n\n  @media screen and (max-width: 900px) {\n      font-size: 20px !important; \n      \n  }\n}\n\n.sponsor-sister-location-image {\n  max-width: 350px; /* Max width for larger screens */\n  margin-bottom: 32px !important; /* Space between image and name */\n  \n  @media (max-width: 900px) {\n      max-width: 250px; /* Adjust width for smaller screens */\n  }\n}\n\n.sponsor-sister-location-logo-container {\n  height: 350px;\n  width: 350px;\n  display: flex; /* Enable flexbox for centering */\n  align-items: center; /* Center vertically */\n  justify-content: center; /* Center horizontally */\n  overflow: hidden; /* Prevent logos from spilling out */\n\n  @media (max-width: 900px) {\n      height: 250px; /* Adjust height for smaller screens */\n      width: 250px; /* Adjust width for smaller screens */\n  }\n}\n\n.sponsor-sister-location-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr) !important; /* Two columns by default */\n  gap: 100px; /* Space between items */\n  margin: 16px 0; /* Margin around the container */\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0px 32px;\n\n  @media screen and (max-width: 900px) {\n      max-width: 400px;\n      grid-template-columns: repeat(1, 1fr) !important; /* Two columns by default */\n\n      \n  }\n}\n\n.sponsor-sister-location-secondary-image {\n  height: 350px; /* Maintain aspect ratio */\n  max-width: 350px; /* Max width for larger screens */\n  margin-bottom: 32px !important; /* Space between image and name */\n  \n  @media (max-width: 900px) {\n      max-width: 4500px; /* Adjust width for smaller screens */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
